import { Link, createFileRoute } from "@tanstack/react-router";
import React from "react";

import { ui } from "@patient-watch/ui";

const Test = () => {
    return (
        <div className="flex flex-row flex-wrap justify-center items-center p-16">
            <ui.Button asChild>
                <Link
                    to="/signup"
                    search={{
                        role: "PATIENT",
                        organisation: {
                            organisation_id: "aabbf84d-77e9-4beb-9d08-212158608aa7",
                            organisation_key: "FISHER2024",
                        },
                    }}
                >
                    Fisher's Signup
                </Link>
            </ui.Button>
        </div>
    );
};

export const Route = createFileRoute("/_auth/test")({
    component: Test,
});
